import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { ServicejobSelectRaStepComponent } from 'src/app/_components/remote-action-step/servicejob-select-ra-step/servicejob-select-ra-step.component';

@Injectable()
export class ServicejobSelectRemoteActionBuilderUIStep
  implements GenericRemoteActionBuilderUIStep {
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(
      this.constructor.name,
      '- getComponent for Servicejob-Select called'
    );
    return ServicejobSelectRaStepComponent;
  }

  public isVisible(currentData: any): boolean {
    if (currentData.privattrip === true) {
      return false;
    }
    return true;
  }
}
